import React, { useEffect, useContext } from "react";
import { HomeBodyContainer } from "App/styles";
import Sponsors from "components/Sponsors";
import History from "components/History";
import ExplanatoryCards from "components/ExplanatoryCards";
import ActionCards from "components/ActionCards";
import EntryWorkflow from "components/EntryWorkflow";
import { SiteConfigContext } from "contexts/SiteConfigContext";
import { AuthContext } from "contexts/AuthContext";

export default function Home() {
  const { home } = useContext(SiteConfigContext);
  const { currentUserRoles } = useContext(AuthContext);

  useEffect(() => {
    document.title = `Inicio | Premios Sadosky`;
  }, []);

  // Las tarjetas de entradas y de sponsor comparten componente: si ninguna de las
  // dos está visible no hace falta renderizarlo.
  const showActionCards = home.showTickets || home.showSponsorCta;

  // El proceso sólo lo ven quienes participan de él: CEO y prensa también
  // se loguean, pero no tienen ningún paso a cargo.
  const showWorkflow =
    currentUserRoles.administrator ||
    currentUserRoles.selector ||
    currentUserRoles.judge;

  return (
    <HomeBodyContainer>
      <ExplanatoryCards />
      {showWorkflow && <EntryWorkflow overHero={false} />}
      {showActionCards && <ActionCards />}
      {home.showSponsors && <Sponsors />}
      {home.showHistoryLink && <History />}
    </HomeBodyContainer>
  );
}
